module.exports = { "default": require("core-js/library/fn/number/max-safe-integer"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/number/max-safe-integer.js
// module id = 777
// module chunks = 0